var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-page"},[_c('div',{staticClass:"menu"},[_c('z-menu')],1),_c('div',{staticClass:"content"},[(_vm.displayNotFound)?_c('not-found'):_c('router-view')],1),_c('notifications',{attrs:{"group":"notifications"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }